/* ============================================================================
   STEP 2's COMPANION PICKER — WHICH BANDANA, WHICH CAP, WHICH HAT

   The owner, 26 August 2026: "подвяжи выбор банданы с модалки как на хом пейдже
   выбор из модалки существующих" and "когда была бандана допустим появлялось ее
   фото". Choosing an option in step 2 opens a modal of the garments that really
   exist, and the tile then shows the one that was chosen.

   ---------------------------------------------------------------------------
   THE WHOLE CONTRACT WITH THE CART IS ONE HIDDEN INPUT
   ---------------------------------------------------------------------------
   Each tile carries input[data-mate-select][data-mate-pack="N"]. This file sets
   its value to the chosen variant's id and nothing else. assets/cooper-pdp.js
   already reads every one of those that is not inside a hidden ancestor, parses
   the value and drops anything that is not a positive integer -- so an untouched
   tile contributes nothing, a chosen one contributes exactly one line, and THAT
   FILE NEEDS NO CHANGE. Two scripts writing the cart payload is how a shop adds
   a garment twice, and this one never posts anything at all.

   THE WORDS AND THE THREAD ARE NOT ASKED HERE. Pieces two and three already have
   their own line and their own colour further down the buy box, and the section
   shows those rows for whichever pack is chosen. One place to type a line beats
   two that can disagree.

   ---------------------------------------------------------------------------
   WHAT IS COPIED FROM THE HOME PAGE, AND WHY
   ---------------------------------------------------------------------------
   The set builder solved the same problem tonight and paid for three things that
   are inherited here rather than rediscovered:

     A NATIVE <dialog> IN THE TOP LAYER. The focus trap, the backdrop, the
     Escape key and the return of focus are the browser's. A dialog carrying the
     hidden attribute NEVER OPENS -- [hidden]{display:none} and
     dialog[open]{display:block} are both UA rules and hidden wins -- so the
     markup ships without it.

     THE SCROLL LOCK IS OURS. A modal dialog blocks clicks behind its backdrop
     but the page still scrolls under it in Chrome. And the lock must RESERVE THE
     SCROLLBAR GUTTER first: hiding the root's overflow takes a 15px scrollbar
     away, the page gets 15px wider and everything behind the backdrop jumps.
     Measured at 14px on this shop before that was fixed.

     THE BACKDROP TEST IS GEOMETRIC. The backdrop and the dialog's own padding
     are the SAME element as far as an event target is concerned, so closing on
     `event.target === dialog` alone would also close the modal when somebody
     pressed the gap beside the heading.

   AND ONE THING IT DOES NOT COPY: the cards are built on first open and kept.
   35 garments of markup on every product page is weight every visitor pays for a
   panel most never open.
   ========================================================================= */
(() => {
  const dialog = document.querySelector('[data-companion-dialog]');
  if (!dialog) return;

  const groups = [...dialog.querySelectorAll('[data-companion-group]')];
  const detail = dialog.querySelector('[data-companion-detail]');
  const titleNode = dialog.querySelector('[data-companion-title]');
  const goneLabel = (dialog.querySelector('[data-companion-gone]') || {}).textContent || '';

  /* WHICH TILE IS BEING FILLED, and the product being configured for it. They
     are cleared together: a tile without a product is how a confirm lands in the
     wrong place. */
  let tile = null;
  let opener = null;
  let product = null;
  let refocusOnClose = true;

  /* WHICH CATEGORY IS OPEN AND WHICH PIECE IT IS FILLING. The chart shown has to
     be the one for the category being chosen, and the name written into step 3
     has to land on the row the buyer is actually filling -- neither is knowable
     from the product alone. */
  let activeGroup = null;
  let activePiece = '';

  const root = document.documentElement;
  const lock = () => {
    /* Measured before the overflow moves, and only asked for when there really
       is a bar to replace: on a short page, or with overlay scrollbars, adding
       a gutter would shift the layout the other way. */
    const bar = window.innerWidth - root.clientWidth;
    if (bar > 0) root.style.scrollbarGutter = 'stable';
    root.style.overflow = 'hidden';
  };
  const unlock = () => {
    root.style.overflow = '';
    root.style.scrollbarGutter = '';
  };

  /* ------------------------------------------------------------------------
     THE SIZE GUIDE, PER CATEGORY. Same mechanism as the home page set builder:
     the url hangs on the group, so the chart is always the one for the category
     being chosen rather than the one for the product the page is about.

     THE IMAGE HAS NO src UNTIL THE PANEL IS OPENED. A 1000px chart fetched for
     every garment somebody browses past is the same mistake that cost this page
     1077 KB once. A category with no chart hides the control entirely, so it is
     never a summary that opens onto nothing.
     --------------------------------------------------------------------- */
  const chartBox = detail ? detail.querySelector('[data-companion-chart]') : null;
  const chartImg = chartBox ? chartBox.querySelector('[data-companion-chart-img]') : null;

  const setChart = (group) => {
    if (!chartBox) return;
    const url = (group && group.dataset.sizeChart) || '';
    const alt = (group && group.dataset.sizeChartAlt) || '';
    chartBox.open = false;
    chartBox.hidden = !url;
    chartBox.dataset.url = url;
    chartBox.dataset.alt = alt;
    /* A url that has changed must not leave the previous category's chart
       sitting under the summary until the new one arrives. */
    if (chartImg && chartImg.getAttribute('src') && chartImg.getAttribute('src') !== url) {
      chartImg.removeAttribute('src');
      chartImg.setAttribute('alt', '');
    }
  };

  if (chartBox && chartImg) {
    chartBox.addEventListener('toggle', () => {
      if (!chartBox.open) return;
      const url = chartBox.dataset.url || '';
      if (url && chartImg.getAttribute('src') !== url) {
        chartImg.setAttribute('src', url);
        chartImg.setAttribute('alt', chartBox.dataset.alt || '');
      }
    });
  }

  const readJSON = (node) => {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      /* A broken island is a bug in the section, not something to hide from
         whoever is looking for it. */
      console.warn('[companion] product data would not parse', e);
      return [];
    }
  };

  /* ПОДПИСЬ В СПИСКЕ -- ЭТО ТО, ЧЕМ ТОВАРЫ ОТЛИЧАЮТСЯ, А НЕ ВЕСЬ ЗАГОЛОВОК.
     Замер 26 сентября по живому магазину: немецкие заголовки 68 товаров трёх
     коллекций пикера идут от 27 до 65 знаков, медиана 50, против 11-43 и
     медианы 21 в английском. Причина одна: каждый теперь открывается родовой
     головой «Hundehalstuch mit Namen | ». В карточке 146px шириной это четыре
     строки того, что покупатель уже прочитал в заголовке модалки.

     ПОЭТОМУ ПЕРВЫЙ СЕГМЕНТ СНИМАЕТСЯ, а показываются только различающие:
     «Marineblau gestreift | Rückseite Orange». Цвет и узор никогда не стоят в
     первом сегменте, так что теряется только родовое слово.

     ЗАГОЛОВОК БЕЗ ВЕРТИКАЛЬНОЙ ЧЕРТЫ НЕ ТРОГАЕТСЯ -- это все английские, -- так
     что правило не может молча съесть имя, которого не понимает. Полный
     заголовок остаётся в title кнопки, в её доступном имени и на шаге выбора
     размера. */
  const shortName = (full) => {
    const parts = String(full || '')
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean);
    if (parts.length < 2) return String(full || '');
    return parts.slice(1).join(' | ');
  };

  const reset = () => {
    for (const g of groups) g.hidden = true;
    if (detail) detail.hidden = true;
    dialog.dataset.step = 'list';
    product = null;
    tile = null;
    activeGroup = null;
    activePiece = '';
    unlock();
    if (refocusOnClose && opener && document.contains(opener)) opener.focus();
    opener = null;
    refocusOnClose = true;
  };

  const close = (refocus) => {
    refocusOnClose = refocus !== false;
    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
      return;
    }
    dialog.removeAttribute('open');
    reset();
  };

  dialog.addEventListener('close', reset);

  /* ------------------------------------------------------------------------
     THE LIST. Built once per category and kept, so reopening is instant.
     --------------------------------------------------------------------- */
  const buildList = (group) => {
    const list = group.querySelector('[data-companion-list]');
    if (!list || list.dataset.built) return;
    for (const p of readJSON(group.querySelector('[data-companion-data]'))) {
      const li = document.createElement('li');
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'cooper-mate__card';

      if (p.img) {
        const img = document.createElement('img');
        img.src = p.img;
        img.alt = p.alt || '';
        img.width = 160;
        img.height = 160;
        img.loading = 'lazy';
        img.decoding = 'async';
        card.appendChild(img);
      }
      const t = document.createElement('span');
      t.className = 'cooper-mate__card-name';
      t.textContent = shortName(p.t);
      t.title = p.t || '';
      card.appendChild(t);

      const pr = document.createElement('span');
      pr.className = 'cooper-mate__card-price tech';
      pr.textContent = p.p || '';
      card.appendChild(pr);

      /* SOLD OUT IS SAID, NOT HIDDEN. A garment whose every size is gone is
         still the one in the photograph the buyer came back for. */
      if (!(p.v || []).some((v) => v.a)) {
        card.setAttribute('aria-disabled', 'true');
        const s = document.createElement('span');
        s.className = 'cooper-mate__card-gone tech';
        s.textContent = goneLabel;
        card.appendChild(s);
      }

      /* КНОПКА НАЗЫВАЕТСЯ ПОЛНЫМ ЗАГОЛОВКОМ, хотя видимая подпись короткая:
         сокращённая подпись не должна сокращать то, что читает скринридер. */
      card.setAttribute(
        'aria-label',
        [p.t || '', p.p || '', card.getAttribute('aria-disabled') === 'true' ? goneLabel : '']
          .filter(Boolean)
          .join(', ')
      );

      card.addEventListener('click', () => {
        if (card.getAttribute('aria-disabled') === 'true') return;
        showDetail(p);
      });

      li.appendChild(card);
      list.appendChild(li);
    }
    list.dataset.built = 'true';
  };

  /* ------------------------------------------------------------------------
     THE DETAIL STEP. One question, asked the same way every time.
     --------------------------------------------------------------------- */
  const sizeName = 'cooper-mate-size';

  function showDetail(p) {
    if (!detail) return;
    product = p;

    const img = detail.querySelector('[data-companion-detail-img]');
    const name = detail.querySelector('[data-companion-detail-title]');
    const price = detail.querySelector('[data-companion-detail-price]');
    const sizes = detail.querySelector('[data-companion-sizes]');
    const confirm = detail.querySelector('[data-companion-confirm]');

    if (img) {
      if (p.img) {
        img.src = p.img;
        img.alt = '';
        img.hidden = false;
      } else {
        img.hidden = true;
        img.removeAttribute('src');
      }
    }
    if (name) name.textContent = p.t || '';
    if (price) price.textContent = p.p || '';
    setChart(activeGroup);

    /* REAL RADIOS, created here rather than written into the page: native
       single-select, native arrow keys, and no aria-checked to keep in step with
       a class. They group by `name` whether or not they are in a form. */
    if (sizes) {
      sizes.textContent = '';
      for (const v of p.v || []) {
        const label = document.createElement('label');
        label.className = 'cooper-mate__size';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = sizeName;
        input.value = String(v.id);
        input.dataset.size = v.o || '';
        if (!v.a) {
          input.disabled = true;
          label.dataset.gone = 'true';
        }
        const face = document.createElement('span');
        face.textContent = v.o || '';
        label.appendChild(input);
        label.appendChild(face);
        input.addEventListener('change', () => {
          if (confirm) confirm.disabled = false;
        });
        sizes.appendChild(label);
      }
    }

    /* COMING BACK TO CHANGE A PIECE KEEPS ITS SIZE, but only when it is the same
       garment: carrying a hat's size across to a bandana would be a guess
       printed into a size field. */
    if (confirm) confirm.disabled = true;
    const already = tile && tile.querySelector('[data-mate-select]');
    if (already && already.value && sizes) {
      const back = [...sizes.querySelectorAll('input')].find((i) => i.value === already.value);
      if (back && !back.disabled) {
        back.checked = true;
        if (confirm) confirm.disabled = false;
      }
    }

    detail.hidden = false;
    dialog.dataset.step = 'detail';
    if (name) {
      if (!name.id) name.id = 'cooper-mate-detail-title';
      dialog.setAttribute('aria-labelledby', name.id);
    }
    dialog.focus({preventScroll: true});
  }

  /* ------------------------------------------------------------------------
     OPENING, FROM A TILE.
     --------------------------------------------------------------------- */
  const open = (button) => {
    const handle = button.dataset.collection || '';
    const group = groups.find((g) => g.dataset.companionGroup === handle);
    if (!group) return;

    tile = button.closest('[data-mate-tile]');
    opener = button;
    activeGroup = group;
    activePiece = button.dataset.piece || '';
    for (const g of groups) g.hidden = g !== group;
    if (detail) detail.hidden = true;
    dialog.dataset.step = 'list';
    if (titleNode) titleNode.textContent = button.dataset.chooseLabel || '';
    buildList(group);

    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        /* No top layer in this browser. It then opens in flow where it stands,
           which is a worse experience and a working one. */
        dialog.setAttribute('open', '');
        dialog.scrollIntoView({block: 'nearest', behavior: 'smooth'});
      }
    }
    lock();
    dialog.setAttribute('aria-label', button.dataset.chooseLabel || '');
    dialog.focus({preventScroll: true});
  };

  for (const button of document.querySelectorAll('[data-companion-open]')) {
    button.addEventListener('click', () => open(button));
  }

  /* ------------------------------------------------------------------------
     CONFIRMING. The variant id goes into the tile's hidden input, and the tile
     starts showing the garment that is actually in the order.
     --------------------------------------------------------------------- */
  if (detail) {
    const confirm = detail.querySelector('[data-companion-confirm]');
    const back = detail.querySelector('[data-companion-back]');

    const commit = () => {
      if (!tile || !product) return;
      const chosen = detail.querySelector('[data-companion-sizes] input:checked');
      if (!chosen) return;

      const field = tile.querySelector('[data-mate-select]');
      if (field) field.value = chosen.value;

      /* THE TILE SHOWS WHAT WAS CHOSEN, which is the half the owner asked for
         twice: "когда была бандана допустим появлялось ее фото". Without it his
         choice existed only as a number in a hidden input. */
      const shot = tile.querySelector('[data-mate-shot]');
      const empty = tile.querySelector('[data-mate-empty]');
      const nameNode = tile.querySelector('[data-mate-name]');
      if (shot) {
        if (product.img) {
          shot.src = product.img;
          shot.alt = '';
          shot.hidden = false;
        } else {
          shot.hidden = true;
        }
      }
      if (empty) empty.hidden = Boolean(product.img);
      if (nameNode) {
        const size = chosen.dataset.size ? ', ' + chosen.dataset.size : '';
        nameNode.textContent = (product.t || '') + size;
      }
      tile.dataset.chosen = 'true';

      /* THE ROW IN STEP 3 TAKES THE GARMENT'S NAME, which the owner asked for
         directly: "в 3 пункте отображаться не Piece 2 а то что я выбрал название
         полное". It printed "Piece 2" because the label was built from the
         fixed-product settings step 2 stopped using -- both empty, so the loop
         emitted nothing and the generic label won.

         THE FULL TITLE, WITHOUT THE SIZE, so it matches the string piece one
         shows above it. The size is already stated in the overview, and a row
         label that says it twice reads as two different pieces.

         Written here rather than in cooper-pdp.js because this is the only place
         that knows what was chosen, and one commit writing the id, the
         photograph and the name together cannot go half done. */
      if (activePiece) {
        const row = document.querySelector('[data-pdp-piece="' + activePiece + '"]');
        const nameSlot = row && row.querySelector('[data-piece-name]');
        const fallback = row && row.querySelector('[data-piece-fallback]');
        if (nameSlot) {
          nameSlot.textContent = product.t || '';
          nameSlot.hidden = !product.t;
        }
        if (fallback) fallback.hidden = Boolean(product.t);
      }

      /* The buy box recomputes its own price and label from the pack and the
         mates; telling it something changed is cheaper and safer than reaching
         into it. It listens for `change` on the form it owns. */
      if (field) field.dispatchEvent(new Event('change', {bubbles: true}));

      close(true);
    };

    if (confirm) confirm.addEventListener('click', commit);
    if (back) {
      back.addEventListener('click', () => {
        detail.hidden = true;
        dialog.dataset.step = 'list';
        product = null;
        const group = groups.find((g) => !g.hidden);
        if (group) {
          dialog.setAttribute('aria-label', (titleNode && titleNode.textContent) || '');
          dialog.focus({preventScroll: true});
        }
      });
    }
  }

  for (const x of dialog.querySelectorAll('[data-companion-close]')) {
    x.addEventListener('click', () => close(true));
  }

  /* ESCAPE IS THE BROWSER'S once the dialog is modal: it fires `cancel` then
     `close`, and reset runs off the second. The handler below is only for the
     fallback path, where the element is an ordinary box with an `open`
     attribute and no key does anything on its own. */
  if (typeof dialog.showModal !== 'function') {
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close(true);
    });
  }

  /* A PRESS ON THE BACKDROP CLOSES IT, tested geometrically rather than by
     target: the backdrop and the dialog's own padding are the same element as
     far as an event target is concerned. */
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    const inside =
      event.clientX >= r.left &&
      event.clientX <= r.right &&
      event.clientY >= r.top &&
      event.clientY <= r.bottom;
    if (!inside) close(true);
  });
})();
